/**
 * neonSigns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const neonSignsPack: ToilePack = {
    slug: 'neon-signs',
    category: 'neon',
    name: 'Neon signs',
    tagline: tagline('signs', 'motifs', 'settings'),
    chips: chips('motifs', 'settings'),
    ratio: SQUARE,
    readings: [
        {key: 'coffee', label: 'Coffee', subject: 'a neon coffee cup with three rising steam curls'},
        {key: 'flamingo', label: 'Flamingo', subject: 'a neon flamingo on one leg beside a palm frond'},
        {key: 'bolt', label: 'Lightning bolt', subject: 'a neon lightning bolt inside a ring'},
    ],
    styles: [
        {key: 'brick', label: 'Tube on brick', style: 'classic tube on exposed brick, a dim bar behind', palette: 'warm white and red tubing', framing: 'straight on, glow and halo'},
        {key: 'pastel', label: 'Pastel wall art', style: 'pastel wall art on a painted wall in daylight', palette: 'soft pink and mint tubing', framing: 'straight on, gentle glow'},
        {key: 'cyber', label: 'Cyber', style: 'cyber, deep blue night and faint fog', palette: 'intense cyan and magenta tubing', framing: 'straight on, wet reflective surface'},
    ],
    directions: ['an open sign instead', 'in warm amber tubing', 'with a word in script'],
}
